import { useState } from "react";
import { desdeQuando } from "./estados";
import type { EstadoDeAcesso, PedidoDeAcesso, PerfilQualidade } from "../types";

export type GerarLink = (publicId: string) => Promise<PedidoDeAcesso | null>;

/** Estados em que faz sentido pedir o acesso ao cliente. */
export const PEDE_ACESSO: EstadoDeAcesso[] = ["SEM_ACESSO", "ACESSO_SOLICITADO"];

/** Guarda os links gerados nesta sessão por cima do que veio da lista. */
export const usePedidosDeAcesso = (onGerarLink: GerarLink) => {
  const [pedidos, setPedidos] = useState<Record<string, PedidoDeAcesso>>({});
  const [gerando, setGerando] = useState<string | null>(null);
  const gerar = async (publicId: string) => {
    setGerando(publicId);
    const pedido = await onGerarLink(publicId);
    if (pedido) setPedidos((atual) => ({ ...atual, [publicId]: pedido }));
    setGerando(null);
  };
  const pedidoDe = (perfil: PerfilQualidade) => pedidos[perfil.publicId] ?? perfil.acesso ?? null;
  return { pedidoDe, gerar, gerando };
};

/** Em que pé está o pedido, em palavras de quem opera. */
export const situacaoDoPedido = (pedido: PedidoDeAcesso): { rotulo: string; cor: "cinza" | "azul" | "amarela" | "verde" | "vermelha" } => {
  switch (pedido.status) {
    case "CONCLUIDO":
      return { rotulo: `Acesso concedido ${desdeQuando(pedido.concludedAt)}`, cor: "verde" };
    case "CONVITE_ENVIADO":
      return { rotulo: "Convite criado · aceite pendente", cor: "amarela" };
    case "AGUARDANDO_ESCOLHA":
      return { rotulo: "Cliente entrou · falta escolher o perfil", cor: "azul" };
    case "ABERTO":
      return { rotulo: `Cliente abriu o link ${desdeQuando(pedido.openedAt)}`, cor: "azul" };
    case "ERRO":
      return { rotulo: "Falhou · cliente pode tentar de novo", cor: "vermelha" };
    default:
      return { rotulo: `Link gerado ${desdeQuando(pedido.createdAt)} · ainda não aberto`, cor: "cinza" };
  }
};

export const linkDoWhatsApp = (texto: string): string => `https://wa.me/?text=${encodeURIComponent(texto)}`;

